import React from 'react';

interface IIconProps {
  style?: any;
  fillColor?: string;
}

const UploadIcon:React.FC<IIconProps> = (props: IIconProps) => {
  return (    
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.92235 16H4.63059C2.07736 16 0 13.9226 0 11.3694C0 10.8495 0.42127 10.4282 0.941176 10.4282C1.46108 10.4282 1.88235 10.8495 1.88235 11.3694C1.88235 12.8847 3 14.6968 4.63059 14.3144H8.92235C11 14.1968 11.6706 12.8847 11.6706 11.3694C11.6706 10.8495 12.0919 10.4282 12.6118 10.4282C13.1317 10.4282 13.5529 10.8495 13.5529 11.3694C13.5529 13.9226 11.4756 16 8.92235 16Z" fill="#112240"/>
<path d="M6.77711 11.9717C6.25721 11.9717 5.83594 11.5505 5.83594 11.0306V1.43056C5.83594 0.91065 6.25721 0.48938 6.77711 0.48938C7.29702 0.48938 7.71829 0.91065 7.71829 1.43056V11.0306C7.71829 11.5505 7.29702 11.9717 6.77711 11.9717Z" fill="#112240"/>
<path d="M2.32363 6.81412C2.09888 6.81412 1.87337 6.73393 1.69342 6.57167C1.30754 6.22343 1.27704 5.62823 1.62528 5.24235L6.07704 0.310588C6.25398 0.114447 6.50509 0.00188235 6.76937 0C6.77163 0 6.77351 0 6.77577 0C7.03779 0 7.28777 0.109176 7.46584 0.301176L11.9176 5.10117C12.2711 5.48216 12.2485 6.07774 11.8675 6.43124C11.4865 6.78475 10.891 6.76216 10.5375 6.38117L6.78518 2.33525L3.02274 6.50353C2.83676 6.70946 2.58076 6.81412 2.32363 6.81412Z" fill="#112240"/>
</svg>


  )
}

export default UploadIcon;